import { Image } from '@mantine/core';
import clsx from 'clsx';
import logoImage from '../../assets/logo.png';
import { Link } from './link';

interface LogoProps {
  height?: number;
}

const Logo: React.FC<React.AnchorHTMLAttributes<{}> & LogoProps> = ({ className, height }) => {
  return (
    <Link to="/" className={clsx('inline-flex items-center gap-3', className)}>
      <span
        className="relative overflow-hidden "
        style={{
          ...(height && { height })
        }}>
        <Image src={logoImage} alt="Logo" />
      </span>
    </Link>
  );
};

export default Logo;
